import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

const Container = styled.div`
  height: 5px;
  display: grid;
  grid-template-columns: 1fr 15px 1fr;
  grid-column-gap: 6px;
  margin-bottom: 38px;
`;
const Stroke = styled.div`
  border-top: 1px solid #909090;
  margin: 10px 0;
`;
const Paragraph = styled.p`
  margin 0;
  font-size: 12px;
  text-align: center;
`;

const StrokeBox = () => (
  <Container>
    <Stroke />
    <Paragraph>
      <FormattedMessage
        id="k.or"
        defaultMessage="or"
      />
    </Paragraph>
    <Stroke />
  </Container>
);

export default StrokeBox;
